import {
  State as ConfigState,
  ActiveRules,
} from "../../../context/settings/config/types";
import { RuleSetting } from "../../../context/settings/types";

export function calcSelectAllConfig(
  ruleList: RuleSetting[],
  configState: ConfigState
) {
  const active = ruleList.reduce(
    (acc: ActiveRules, rule) => {
      const existing =
        configState.active[rule.rule.id] || configState.saved[rule.rule.id];
      if (existing) {
        const updated = {
          id: existing.id,
          rule: existing.rule,
          priority: existing.priority,
        };
        acc[rule.rule.id] = updated;
        return acc;
      }

      acc[rule.rule.id] = {
        id: rule.id,
        rule: rule.rule,
        priority: 1,
      };
      return acc;
    },
    { ...configState.active }
  );
  return active;
}

export function calcRemoveAllConfig(
  ruleList: RuleSetting[],
  configState: ConfigState
) {
  const active = { ...configState.active };
  ruleList.forEach((rule) => {
    if (active[rule.rule.id]) {
      delete active[rule.rule.id];
    }
  });

  return active;
}
